import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';

import DiscoverAlbumFolderFaces from '../../components/discover/DiscoverAlbumFolderFaces';
import {
  onSelectIdentity,
  resetAlbumDiscovery,
} from '../../actions/discover-album-folder';
import { openModal } from '../../actions/modal-actions';
import { AlbumFolderWithCreatorBrandDetails } from '../../graphql/queries/album-folder';
import { MeWithIdentities } from '../../graphql/queries/account';

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  albumFolderId: discoverAlbumFolder.albumFolderId,
  identities: discoverAlbumFolder.identities,
});

const mapDispatchToProps = dispatch => ({
  onSelectIdentity: identity => dispatch(onSelectIdentity(identity)),
  openModal: modal => dispatch(openModal(modal)),
  resetAlbumDiscovery: () => dispatch(resetAlbumDiscovery()),
});

const withAlbumFolderData = graphql(AlbumFolderWithCreatorBrandDetails, {
  options: ({ albumFolderId }) => ({
    variables: {
      id: albumFolderId,
    },
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loading,
  }),
  skip: ({ albumFolderId }) => !albumFolderId,
});

const withUserData = graphql(MeWithIdentities, {
  props: ({ data: { me } = {} }) => ({
    accountId: me?.id,
  }),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withUserData,
  withAlbumFolderData,
)(DiscoverAlbumFolderFaces);
